/**
 * Guided tour types for Templatical Editor `init()` / `initCloud()`.
 */

/** Reserved tooltip placement hints for layout inside the viewport. */
export type EditorTourStepPlacement =
  | "canvas"
  | "sidebar"
  | "rightSidebar"
  | "below";

export interface EditorTourStep {
  /** Any valid `document.querySelector` selector (editor internals or host DOM). */
  target: string;
  title: string;
  text: string;
  placement?: EditorTourStepPlacement;
  /**
   * When the target is absent, skip this step. Default `true`.
   * Set `false` to keep the step even if the node is missing (rect will be null — avoided).
   */
  skipIfMissing?: boolean;
}

export interface EditorTourConfig {
  /**
   * Steps to show in order. Omit to use built-in defaults (canvas, block rail, right sidebar).
   */
  steps?: EditorTourStep[];
  /** Start automatically after mount when the tour has not been dismissed. Default `false`. */
  autoStart?: boolean;
  /**
   * `localStorage` key for dismissal persistence.
   * Set to `false` to disable persistence (tour can restart every load).
   * Default key is `DEFAULT_EDITOR_TOUR_STORAGE_KEY` when omitted.
   */
  storageKey?: string | false;
}

export interface EditorTourStartOptions {
  /** Zero-based index into the active (filtered) step list */
  stepIndex?: number;
}

export const DEFAULT_EDITOR_TOUR_STORAGE_KEY =
  "templatical-editor-tour-dismissed";
